module.exports = __webpack_public_path__ + "static/media/sprite-cards-rodape.1673ea9a.png";